import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiPost, apiPut } from '@/api/client';
import { toast } from 'sonner';

export function useCreateTable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { columns: any[]; tableName?: string; carrierId?: string; overrideAndCommission?: string }) =>
      apiPost('/tables', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['carriers'] });
      toast.success('Table created successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create table');
    },
  });
}

export function useEditTable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { tableId: string; columns: any[] }) =>
      apiPut(`/tables/${data.tableId}`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['carriers'] });
      toast.success('Table updated successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update table');
    },
  });
}

export function useEditMapping() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { tableId: string; mapping: Record<string, string> }) =>
      apiPut(`/tables/${data.tableId}/mapping`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['carriers'] });
      toast.success('Mapping updated successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update mapping');
    },
  });
}

export function useCreateMemberTemplateTable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { columns: any[] }) =>
      apiPost('/member-template/table', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['memberTemplate'] });
      toast.success('Member template table created successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create member template table');
    },
  });
}

export function useEditMemberTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { columns: any[] }) =>
      apiPut('/member-template', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['memberTemplate'] });
      toast.success('Member template updated successfully');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to update member template');
    },
  });
}
